enum CmsPageProjectSelectboxTypesEnum {
    LOAD_SUCCESS = "PORTAL_LOAD_CMS_PAGE_PROJECT_SELECTBOX_success",
    LOAD_ERROR = "PORTAL_LOAD_CMS_PAGE_PROJECT_SELECTBOX_error",
}

export default CmsPageProjectSelectboxTypesEnum;
